module.exports = __webpack_public_path__ + "static/opensans-extrabolditalic-webfont-cd4b3ccf7b3d581cd373a17e858b3ce6.woff";